"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultState = exports.updateForm = exports.removeBillingByAddAddressClear = exports.removeBillingByAddAddress = exports.removeToast = exports.actionType = exports.makePrimary = exports.removeAddress = exports.buildAddress = exports.UPDATE_FORM = exports.REMOVE_BILLING_ADD_ADDRESS = exports.REMOVE_ADDRESS = exports.REMOVE_TAG = exports.REMOVE_TOAST = exports.TYPE_ACTION = exports.MAKE_PRIMARY = exports.BUILD_ADDRESS = void 0;
exports.BUILD_ADDRESS = "BUILD_ADDRESS";
exports.MAKE_PRIMARY = "MAKE_PRIMARY";
exports.TYPE_ACTION = "OPTIONS_CLICKED";
exports.REMOVE_TOAST = "REMOVE_TOAST";
exports.REMOVE_TAG = "REMOVE_TAG";
exports.REMOVE_ADDRESS = "REMOVE_ADDRESS";
exports.REMOVE_BILLING_ADD_ADDRESS = "REMOVE_BILLING_ADD_ADDRESS";
exports.UPDATE_FORM = "UPDATE_FORM";
function buildAddress(addressInfo) {
    return {
        type: [exports.BUILD_ADDRESS],
        addressData: addressInfo,
    };
}
exports.buildAddress = buildAddress;
function removeAddress(addressInfo) {
    return {
        type: [exports.REMOVE_ADDRESS],
        addressData: addressInfo,
    };
}
exports.removeAddress = removeAddress;
function makePrimary(allAddresses) {
    return {
        type: [exports.MAKE_PRIMARY],
        modifiedAddressesObj: allAddresses,
    };
}
exports.makePrimary = makePrimary;
function actionType(value) {
    return {
        type: [exports.TYPE_ACTION],
        typeOfAction: value,
    };
}
exports.actionType = actionType;
function removeToast(value) {
    return {
        type: [exports.REMOVE_TOAST],
        typeOfAction: value,
    };
}
exports.removeToast = removeToast;
function removeBillingByAddAddress() {
    return {
        type: [exports.REMOVE_BILLING_ADD_ADDRESS],
        removeBilling: { isAddAddress: true },
    };
}
exports.removeBillingByAddAddress = removeBillingByAddAddress;
function removeBillingByAddAddressClear() {
    return {
        type: [exports.REMOVE_BILLING_ADD_ADDRESS],
        removeBilling: { isAddAddress: false },
    };
}
exports.removeBillingByAddAddressClear = removeBillingByAddAddressClear;
function updateForm(value) {
    return {
        type: [exports.UPDATE_FORM],
        updatedForm: value,
    };
}
exports.updateForm = updateForm;
exports.DefaultState = {
    addressData: "",
    typeOfAction: "",
    removeBilling: undefined,
    updatedForm: "",
};
